/*REACT*/
import { useEffect } from "react";
import { Box, Typography } from "@mui/material";

import schema from "./schema";
import { Request } from "./datalink";

import Datumizo from "Components/LabIZO/Datumizo/Datumizo";
import { VStack } from "Components/LabIZO/Stackizo";
import { ColorX, Authority, ErrorX } from "static";
import { store } from "static";
import axios from "axios";
import { DOMAIN } from "../../config/config";
import { AccessTime, CastForEducation, Close, SkipNext } from "@mui/icons-material";
import { DatumizoBase, DatumizoButtonProps } from "Components/LabIZO/Datumizo/DatumizoProps.interface";
const T2VATrainer = () => {
  useEffect(() => {
    Authority.Require("T2VATrainer");
  }, []);
  let dtizo: any = null;
  const MountDtizo = (callback: any) => {
    dtizo = callback;
  };

  const Learn = {
    onClick: (id: string, data: object) => {
      store.Ask("Learn", "Confirm Changes", async () => {
        await Learn.onConfirm(id, data);
      });
    },
    onConfirm: async (id: string, data: object) => {
      console.log("Learn");
      let url = DOMAIN + Request.Learn;
      let payload = {
        data: data,
        JWT: store.user.JWT,
      };
      try {
        let res = await axios.post(url, payload);
        if (res.data.Success === true) {
          Learn.onSuccess(res);
        } else {
          Learn.onFail(res.data?.payload);
        }
      } catch (e) {
        Learn.onFail(e);
      }
    },
    onSuccess: (res: any) => {
      store.Alert("Learn", "success");
      dtizo.Reload(true);
    },
    onFail: (e: any) => {
      const msg = "Cannot learn example: " + e.message;
      ErrorX.Handle({ ...e, message: msg });
      dtizo.Reload();
    },
  };

  const Pass = {
    onClick: (id: string, data: object) => {
      store.Ask("Pass", "Confirm Changes", async () => {
        await Pass.onConfirm(id, data);
      });
    },
    onConfirm: async (id: string, data: object) => {
      console.log("Pass");
      let url = DOMAIN + Request.Pass;
      let payload = {
        data: data,
        JWT: store.user.JWT,
      };
      try {
        let res = await axios.post(url, payload);
        if (res.data.Success === true) {
          Pass.onSuccess(res);
        } else {
          Pass.onFail(res.data?.payload);
        }
      } catch (e) {
        Pass.onFail(e);
      }
    },
    onSuccess: (res: any) => {
      store.Alert("Set to Pass", "success");
      dtizo.Reload(true);
    },
    onFail: (e: any) => {
      const msg = "Cannot set example to pass: " + e.message;
      ErrorX.Handle({ ...e, message: msg });
      dtizo.Reload();
    },
  };

  const Pending = {
    onClick: (id: string, data: object) => {
      store.Ask("Discuss", "Confirm Changes", async () => {
        await Pending.onConfirm(id, data);
      });
    },
    onConfirm: async (id: string, data: object) => {
      console.log("Pass");
      let url = DOMAIN + Request.Pending;
      let payload = {
        data: data,
        JWT: store.user.JWT,
      };
      try {
        let res = await axios.post(url, payload);
        if (res.data.Success === true) {
          Pending.onSuccess(res);
        } else {
          Pending.onFail(res.data?.payload);
        }
      } catch (e) {
        Pending.onFail(e);
      }
    },
    onSuccess: (res: any) => {
      store.Alert("Set to Pending", "success");
      dtizo.Reload(true);
    },
    onFail: (e: any) => {
      const msg = "Cannot set example to pending: " + e.message;
      ErrorX.Handle({ ...e, message: msg });
      dtizo.Reload();
    },
  };

  const Reject = {
    onClick: (id: string, data: object) => {
      store.Ask("Reject", "Confirm Changes", async () => {
        await Reject.onConfirm(id, data);
      });
    },
    onConfirm: async (id: string, data: object) => {
      let url = DOMAIN + Request.Reject;
      let payload = {
        data: data,
        JWT: store.user.JWT,
      };
      try {
        let res = await axios.post(url, payload);
        if (res.data.Success === true) {
          Reject.onSuccess(res);
        } else {
          Reject.onFail(res.data?.payload);
        }
      } catch (e) {
        Reject.onFail(e);
      }
    },
    onSuccess: (res: any) => {
      store.Alert("Set to Rejected", "success");
      dtizo.Reload(true);
    },
    onFail: (e: any) => {
      const msg = "Cannot set example to reject: " + e.message;
      ErrorX.Handle({ ...e, message: msg });

      dtizo.Reload();
    },
  };

  const base: DatumizoBase = {
    title: "Generic Answers",
    exportDoc: "Generic_Answers",
    schema: schema,
    reqAuth: "T2VATrainer",

    tablizo: {
      columnsToolbar: true,
      filterToolbar: true,
      densityToolbar: true,
      exportToolbar: false,
      showSelector: true,
    },
    Connect: {
      DeleteBulk: Request.DeleteBulk,
      List: Request.List,
      schema: schema.Table,
    },

    operations: {
      Add: {
        title: "Add Answer",
        url: Request.Add,
        success: "Answer Added Successfully",
        fail: "Answer Add Failed: ",
        schema: schema.Add,
        buttons: ["Clear", "Submit"],
        onSubmit: "Add",
      },
      Delete: {
        title: "Delete this entry?",
        content: "Caution: This is irrevertable.",
        url: Request.Delete,
        success: "Entry Deleted Successfully.",
        fail: "Entry Delete Failed: ",
        onSubmit: "Delete",
      },
      DeleteBulk: {
        title: (n: number) => "Delete these " + n + " entries?",
        content: "Caution: This is irrevertable.",
        url: Request.DeleteBulk,
        success: "Entries Deleted Successfully.",
        fail: "Entries Delete Failed: ",
        onSubmit: "DeleteBulk",
      },
      Edit: {
        title: "Edit Answer ",
        url: Request.Edit,
        success: "Answer Edited Successfully",
        fail: "Answer Edit Failed: ",
        schema: schema.Edit,
        buttons: ["Revert", "Submit"],
        onSubmit: "Edit",
      },
      Info: {
        title: "Training Entry",
        schema: schema.Info,
        readOnly: true,
      },
    },

    buttons: {
      inline: [
        { icon: <CastForEducation />, func: Learn, caption: "Submit to Learn" },
        { icon: <AccessTime />, func: Pending, caption: "Discuss" },
        { icon: <SkipNext />, func: Pass, caption: "Pass" },
        { icon: <Close />, func: Reject, caption: "Reject" },
      ],
      inlineOpposite: [{ icon: "delete", func: "Delete", caption: "Delete", reqFunc: "Delete" }],
      left: [],
      right: [{ icon: "deletebulk", func: "DeleteBulk", caption: (n: number) => "Delete (" + n + ")", reqFunc: "Delete", theme: "caution" }],
    },
  };
  const title = "T2VATrainer";

  return (
    <VStack>
      <Box padding={1} width="100%">
        <Typography
          style={{
            textAlign: "left",
            width: "100%",
            fontSize: 25,
            color: ColorX.GetColorCSS("Primary"),
          }}
        >
          {title}
        </Typography>
      </Box>
      <Datumizo base={base} serverSidePagination={false} onMounted={MountDtizo} />
    </VStack>
  );
};

export default T2VATrainer;
